import popups from '@/hooks/popups'
import { ref, watch } from '@vue/composition-api'
import axios from '@axios';
import { getAccounts } from '@/composables/accountService'
import { getPaymentMethods } from '@/composables/paymentMethodService'
import { getTaxes } from '@/composables/taxService'
import { getStudents } from '@/composables/studentService'
import { getProducts } from '@/composables/productService'
import { getGroups } from '@/composables/groupService'
import { getPublicSettings } from '@/composables/settingsService'
import { getCorrectingReasons } from '@/composables/correctingReasonService'
import { getEconomicActivities } from '@/composables/economicActivityService'
import { getAccountingAccounts } from '@/composables/accountingAccountService';
const { errorToast } = popups()
const discountBeforeUpdated=ref(0)
const vatBeforeUpdated=ref(null)
const pitBeforeUpdated=ref(null)

export default function invoiceUtils(){

    const user = JSON.parse(localStorage.getItem('userData'))
    const invoice = ref({
        user_email: user.email,
        user_full_name: user.fullName,
        user_id: user.id,
        paid: 0,
        amount: 0,
        bank_account_id: null,
        bank_account_iban: '',
        bank_account_swift: '',
        n_invoice: false,
        n_receipt: false,
        n_expense: true,
        emit_date: new Date(Date.now()).toISOString(),
        observations: '',
        payment_date: null,
        payment_method: null,
        is_correlative: true,
        customer_id: null,
        customer: null,
        customer_billing_nif: '',
        customer_billing_city: '',
        customer_billing_full_name: '',
        customer_billing_name: '',
        customer_billing_first_surname: '',
        customer_billing_second_surname: '',
        customer_billing_country: '',
        customer_billing_account: '',
        customer_billing_address: '',
        customer_billing_province: '',
        customer_billing_postal_code: '',
        items: [{   
          id:'',
          code:'',
          item: '',
          name: '',
          vat: null,
          pit: null,
          amount: 0,
          quantity: 1,
          discount: 0,
          observations: '',
          tpye:'',
          accounting_account_id: null,
          accounting_account: '',
          accounting_subaccount: '',  
          is_supplied: false, 
          is_active: false,
          expense_deduction: 100,
          vat_deduction: 100

        }], 
        cash_id:'', 
        serie_id: '',
        serie: null,
        subtotal: 0,
        discounts: 0,
        taxableBase: 0,
        group: null,
        is_legal_entity: null,
        pit: null,
        economic_activity_id: ''
      })


      const item = {
        id:'',
        code:'',
        name: '',
        item: '',
        vat: null,
        pit: null,
        amount: 0,
        quantity: 1,
        discount: 0,
        observations: '',
        tpye:'',
        isNew: true,
        accounting_account_id: null,
        accounting_account: '',
        accounting_subaccount: '',
        is_supplied: false, 
        is_active: false
      }
      const type = ref(null)
      const invoicePit = ref(null)
      const defaultQuery = ref({
        q: '',
        perPage: 1000,
        page: 1,
        sortBy: 'id',
        sortDesc: true, 
      })

      const showCashes = ref(false)
      const applyPIT = ref(false)
      const applyVAT = ref(false)

    //& RECEIPT ITEMS

    /**
     * Calcular el subtotal de un item de la factura
     * @param {InvoiceItem} item 
     * @returns int
     */
    const getItemSubtotal = function(item){
        return item.amount * (item.quantity ?? 1)
    }

    /**
     * Calcular la base imponible de un item de la factura
     * @param {InvoiceItem} item 
     * @returns int
     */
    const getItemTaxableBase = function(item){
        let subtotal = getItemSubtotal(item)

        return subtotal - ((item.discount ?? 0) / 100 * subtotal)
    }

    /**
     * Calcular el total de un item de la factura (incluyendo descuento e impuestos)
     * @param {InvoiceItem} item
     * @returns void
     */
    const getItemTotalAmount = function(item){
        let subtotal = (item.quantity ?? 1) * item.amount
        let taxableBase = subtotal - ((item.discount ?? 0) / 100 * subtotal)
        let vat = 0
        let pit = 0

        if (item.vat) {
            vat = taxableBase * (item.vat / 100)
        }

        if (item.pit && item.pit!==false && item.pit!==true) {
            pit = taxableBase * (item.pit / 100)
        }

        return taxableBase  + vat - pit
    }

    /**
     * Calcular los importes de un item de la factura
     * @param {InvoiceItem} item 
     * @returns void
     */
    const calculateItem = function(item){
        item.total = getItemTotalAmount(item)

        return item.total
    }

    //& RECEIPT
    
    /**
     * Calcular el subtotal de la factura
     * @param {Invoice} invoice 
     * @returns int
     */
    const getSubtotal = function(){
        let subtotal = 0
        invoice.value.items.forEach(item => {
            subtotal += item.amount * (item.quantity ?? 1)
        });

        return subtotal
    }

    /**
     * Calcular los descuentos de la factura
     * @param {Invoice} invoice 
     * @returns int
     */
    const getDiscount = function(){
        let discounts = 0
        invoice.value.items.forEach(item => {
            discounts += (item.discount ?? 0) / 100 * item.amount * (item.quantity ?? 1)
        });

        return discounts
    }
    
    /**
     * Calcular la base imponible de la factura
     * @param {Invoice} invoice 
     * @returns int
     */
    const getTaxableBase = function(){
        let taxableBase = 0
        invoice.value.items.forEach(item => {
            taxableBase += (item.amount * (item.quantity ?? 1)) - ((item.discount ?? 0) / 100 * item.amount * (item.quantity ?? 1))
        });

        return taxableBase
    }
    
    /**
     * Calcular los impuestos de la factura
     * @param {Invoice} invoice 
     * @returns array
     */
    const obtainTaxes = function(){
        let vats = []
        invoice.value.items.forEach(item => {
            if (item.vat!==null) {
                let taxableBaseItem = getItemTaxableBase(item)            
                let newVat=taxableBaseItem * (item.vat/100)
                if (vats.length!=0) {
                let index=vats.findIndex(vat=>vat.value==item.vat)
                if (index<0) {
                    vats.push({value: item.vat, price:newVat})
                } else {
                    vats[index].price+=newVat
                }
                } else {
                vats.push({value: item.vat, price:newVat})
                }
            }
        });


        return vats
    }

    /**
     * Calcular el IRPF de la factura
     * @param {Invoice} invoice 
     * @returns void
     */
    const getPits = function() {
        let pits = []
        invoice.value.items.forEach(item => {
            if (item.pit!==null && item.pit!==false && item.pit!==true) {
                let taxableBaseItem = getItemTaxableBase(item)
                let newPit=taxableBaseItem * (item.pit/100)
                if (pits.length!=0) {
                let index2=pits.findIndex(pit=>pit.value==item.pit)
                if (index2<0) {
                    pits.push({value: item.pit, price:newPit})
                } else {
                    pits[index2].price+=newPit
                }
                } else {
                pits.push({value: item.pit, price:newPit})
                }
            }
        });



        return pits
    }

    /**
     * Calcular el total de la factura (incluyendo descuentos e impuestos)
     * @param {Invoice} invoice 
     * @returns int
     */
    const getTotalAmount = function(){
        let total = 0
        invoice.value.items.forEach(item => {
            total += item.total
        });
    
        return total;
    }

    /**
     * Calcular los importes de la factura
     * @param {Invoice} invoice 
     * @returns void
     */
    const calculateInvoice = function(){
        setTaxesVisibility()
        invoice.value.vats = obtainTaxes()  
        invoice.value.pits = getPits()
        invoice.value.subtotal = getSubtotal()
        invoice.value.discounts = getDiscount()
        invoice.value.taxableBase = getTaxableBase()
        invoice.value.items.forEach((item)=>calculateItem(item))
        invoice.value.amount = getTotalAmount()
    }

    
    //&  IMPUESTOS
     /**
     * Establecer los impuestos según las características del tipo de cliente
     * @returns void
     */

     const setTaxes = () => {
       if (itemsOptions.value && (type.value!='n_expense' && type.value!='n_expense_ticket' )) {
         if (invoice.value.customer && invoice.value.customer.customer_type) {
            if (invoice.value.items) {
                if (!invoice.value.customer.customer_type.pit) { setNullPit() }
                if (!invoice.value.customer.customer_type.vat) { setExentVat() }
                if (invoice.value.customer.customer_type.pit) { setPit() }
                if (invoice.value.customer.customer_type.vat) { setVat() }
            }
        } else if (invoice.value.customer) {
            if (invoice.value.items) {
                setVat()
                setNullPit()
            }
            
        }
      }
     }

    /**
     * Establecer a nulos los irpf de los items
     * @returns void
     */

    const setNullPit= () => {
        invoice.value.items.forEach(it=> {
            it.pit=''
        })
    }
    
    /**
     * Establecer a exentos los ivas de los items
     * @returns void
     */
    const setExentVat= () => {
        invoice.value.items.forEach((it)=> {
            it.vat=0.00
        })
    }

    /**
     * Establecer al irpf original si es un item del selector
     * @returns void
     */
    const setPit=() => {
      if (invoice.value.items.length>0) {
            invoice.value.items.forEach(item=> {
              if (item.is_supplied) {
                let index=itemsOptions.value.findIndex(it=> item.code==it.code)
                let originalItem=itemsOptions.value[index];
                if (invoicePit.value && originalItem) {
                    if (item.pit=== true || item.pit=== null) {
                      item.pit=(invoicePit.value && originalItem.pit) ? invoicePit.value : null
                    }
                }
              }
        })
        }
    }


    /**
     * Establecer al iva original si es un item del selector
     * @returns void
     */
    const setVat=() => {
        invoice.value.items.forEach((item)=>{
          if (!item.is_supplied) {
            let index=itemsOptions.value.findIndex(it=> item.id==it.id)
            if (index>=0) {
              item.vat= itemsOptions.value[index].tax.value
            } 
          }
        })
      }

    /**
     * Reestablecer a 'null' los valores requeridos si para un item se selecciona como tipo de ingreso un suplido
     * @param {InvoiceItem} item 
     * @param {boolean} val 
     */
    const onItemTypeInput = (item, val) => {
      if (val) {
        item.vat='0.00'
        item.pit=null
      } else {
        setTaxes()
      }
      item.accounting_account=''
      item.accounting_subaccount=''
    }

    /**
     * Establecer a null la subcuenta si se ha deselecciona en el select la cuenta
     * @param {InvoiceItem} item 
     * @param {AccountingAccount} val 
     */
    const onAccountingInput = (item, val) => {
      if (val===null) {
        item.accounting_subaccount='';
      }
     }


    /**
     * Establecer la cuenta bancaria (la del cliente o la de la empresa) en función del método de pago
     */
    const setBankAccount = () => {
        if (invoice.value.customer && invoice.value.payment_method == "Domiciliaciones de pago" ) {
          if (invoice.value.customer.account) {
            invoice.value.bank_account_iban = invoice.value.customer.account.iban ?? ''
            invoice.value.bank_account_swift = invoice.value.customer.account.swift_bic ?? ''
            invoice.value.bank_account_id = ''
          } else {
            invoice.value.bank_account_iban = invoice.value.customer.iban ?? ''
            invoice.value.bank_account_swift = invoice.value.customer.swift_bic ?? ''
            invoice.value.bank_account_id = ''
          }
        } 
          
        if (invoice.value.customer && invoice.value.payment_method == "Transferencias bancarias") {
          if (invoice.value.group) {
            if (invoice.value.group.bank_accounts.length==1) {
              invoice.value.bank_account_id = invoice.value.group.bank_accounts[0].id
              invoice.value.bank_account_iban = invoice.value.group.bank_accounts[0].iban
              invoice.value.bank_account_swift = invoice.value.group.bank_accounts[0].swift_bic
            }

          }
        }
        


    }

    /**
     * Establecer los datos de facturación de la empresa en función de si hay datos de dirección en la sucursal o no
     */
    const setBillingData = () => {   
        if (invoice.value.group && (invoice.value.group.address!=null && invoice.value.group.city!=null && invoice.value.group.postal_code!=null)) {
          invoice.value.settings_cif=settings.value.cif
          invoice.value.settings_company_name=settings.value.company_name
          invoice.value.settings_address=invoice.value.group.address
          invoice.value.settings_postal_code=invoice.value.group.postal_code
          invoice.value.settings_city=invoice.value.group.city
          invoice.value.settings_province=invoice.value.group.province ? invoice.value.group.province.name :''
          invoice.value.settings_country=invoice.value.group.country ? invoice.value.group.country.name :''
          invoice.value.settings_phone=invoice.value.group.phone

          // IRPF
          invoicePit.value=settings.value.pit ? settings.value.pit.value : null 
        } else {
          invoice.value.settings_cif=settings.value.cif
          invoice.value.settings_company_name=settings.value.company_name
          invoice.value.settings_address=settings.value.address
          invoice.value.settings_postal_code=settings.value.postal_code
          invoice.value.settings_city=settings.value.city
          invoice.value.settings_province=settings.value.province ? settings.value.province.name :''
          invoice.value.settings_country=settings.value.country ? settings.value.country.name :''
          invoice.value.settings_phone=settings.value.phone
          
          // IRPF
          invoicePit.value=settings.value.pit ? settings.value.pit.value : null 
        }
            
        if (invoicePit.value == null) setNullPit();

    }

    /**
     * Establecer el accounting_account_id de todos los items de una factura en función de si hay una subcuenta o no
     */
    const setAccountingAccount = () => {
      invoice.value.items.forEach((item) => {
        if (item.accounting_account) {
          if (item.accounting_subaccount) {
            item.accounting_account_id = item.accounting_subaccount
          } else {
            item.accounting_account_id = item.accounting_account.id
          }
        }
      })

    }


    /**
     * Establecer visibilidad del select de cajas
     */
    const setCashVisibility = () => {
      if (invoice.value.payment_method=="Efectivo" && invoice.value.paid==1) {
        showCashes.value=true
      } else {
        showCashes.value=false
        invoice.value.cash_id=null
      }

    }

    /**
     * Establecer la visibilidad de los campos de IVA e IRPF en función del tipo de cliente
     */
    const setTaxesVisibility = () => {
      if (invoice.value.customer && invoice.value.customer.customer_type) {
        invoice.value.customer.customer_type.pit ? applyPIT.value=true : applyPIT.value=false
        invoice.value.customer.customer_type.vat ? applyVAT.value=true : applyVAT.value=false
      } else {
        applyPIT.value = false
        applyVAT.value = true
      }
    }


    /**
     * Método para establecer la actividad económica en base a la serie.
     */ 
    const setEconomicActivity = () =>  {
      if (invoice.value.serie) {
        invoice.value.economic_activity_id=invoice.value.serie.economic_activity_id
      }
    }



    /**
     * Validar los datos base comunes a todos los tipos de factura
     * @returns {boolean|[]}
     */
    const validateInvoice = () => {
        setAccountingAccount()
        if(!invoice.value.emit_date){ errorToast('Select dates'); return false }
        if(invoice.value.items.length == 0){ errorToast('Añade un item'); return false }
        for (let i of invoice.value.items) { 
          if (!i.item) { errorToast('Introduce un item') ; return false } 
          if (i.vat===false) { errorToast('Falta el IVA de algún item') ; return false }         
        }
        if (!invoice.value.payment_method) { errorToast("Añade un método de pago"); return false }
        if ((!invoice.value.cash_id && invoice.value.paid==1) && invoice.value.payment_method=="Efectivo") { errorToast("Selecciona una caja"); return false }
        if (!invoice.value.group) { errorToast("Añade una sucursal"); return false }
        if ((invoice.value.customer_billing_account==null || invoice.value.customer_billing_full_name==null || invoice.value.customer_billing_nif==null || invoice.value.customer_billing_address==null || invoice.value.customer_billing_province==null || invoice.value.customer_billing_country==null || invoice.value.customer_billing_postal_code==null) && (type && type=='invoice')) { 
            errorToast("Faltan datos de facturación."); return false }
        if ((invoice.value.payment_method == "Domiciliaciones de pago" || invoice.value.payment_method == "Transferencias bancarias") && ((!invoice.value.bank_account_id && !invoice.value.bank_account_iban) || (!invoice.value.bank_account_swift))) {
            errorToast("Falta la cuenta bancaria."); return false;
        }

        invoice.value.serie_id=invoice.value.serie ? invoice.value.serie.id : invoice.value.serie_id
        invoice.value.group_id=invoice.value.group ? invoice.value.group.id : invoice.value.group_id
  
       

        return true
    }

    // // Popover
    // const updateDiscountTax= (index)=> {
    //     invoice.value.items[index].discount=discountBeforeUpdated.value
    //     invoice.value.items[index].vat=vatBeforeUpdated.value
    //     invoice.value.items[index].pit=pitBeforeUpdated.value === null ? false : pitBeforeUpdated.value
    // }

    // const changeToCurrentTax = (index) => {
    //   vatBeforeUpdated.value=invoice.value.items[index].vat;
    //   pitBeforeUpdated.value=invoice.value.items[index].pit;
    //   discountBeforeUpdated.value=invoice.value.items[index].discount;
    // }

    // Inputs
    let timer = ref(0)
    const delay = 500


    /**
     * Realizar la búsqeuda de clientes en función al texto pasado
     * @param {String} text 
     * @returns {void|Array}
     */
    const onCustomerInputChange = (text) => {
      if (text === '' || text === undefined) {
        return 
      }

      clearTimeout(timer)
      timer = setTimeout(() => {
          if(text.length > 2) {
            suggestionsText.value=text
            defaultQuery.value.q=text
            fetchStudents()
            fetchAccounts()
          }
      }, delay)

    }


    /**
     * Realizar la búsqueda de items en función al texto pasado
     * @param {String} text 
     * @returns {void|Array}
     */
    const onItemInputChange = (text) => {
      if (text === '' || text === undefined) {
        return
      }
      const filteredData = itemsOptions.value.filter(function(item){
        return item.name.toLowerCase().includes(text.toLowerCase())
      })

      itemsSuggestions.value = [{
        data: filteredData
      }]
    }

    /**
     * Actualizar los datos de facturación del cliente cuando se introduce uno nuevo
     * @param {Student|Account} val 
     */
    const updateCustomerForm = (val) => {

        const { id, dni, address, city, country, name, first_surname, second_surname, postal_code, province, account, billing_nif, full_name} = val 
        if (dni) {invoice.value.student_id=id;}
        invoice.value.customer = account ?? val
        setBankAccount()
        if (account) invoice.value.account_id=account.id
        else invoice.value.account_id=null
        if (account || billing_nif) {
          let entity
          if (billing_nif) entity = val 
          else entity = account
          invoice.value.customer_billing_full_name = entity.billing_name + ' ' + (entity.billing_first_surname ?? '')  + ' ' + (entity.billing_second_surname ?? '')
          invoice.value.customer_billing_name = entity.billing_name
          invoice.value.customer_billing_first_surname = entity.billing_first_surname
          invoice.value.customer_billing_second_surname = entity.billing_second_surname
          invoice.value.customer_billing_nif =  entity.billing_nif
          invoice.value.customer_billing_address = entity.billing_address
          invoice.value.customer_billing_postal_code = entity.billing_postal_code
          invoice.value.customer_billing_city = entity.billing_city
          invoice.value.customer_billing_province = entity.province ? entity.province.name : null
          invoice.value.customer_billing_country = entity.country  ? entity.country.name  : null
          invoice.value.studentName = full_name
        } else {
          invoice.value.customer_billing_name = name
          invoice.value.customer_billing_first_surname = first_surname
          invoice.value.customer_billing_second_surname = second_surname
          invoice.value.customer_billing_full_name = full_name
          invoice.value.customer_billing_nif =  dni
          invoice.value.customer_billing_address = address
          invoice.value.customer_billing_postal_code = postal_code
          invoice.value.customer_billing_city = city
          invoice.value.customer_billing_province = province ? province.name : null
          invoice.value.customer_billing_country = country  ? country.name  : null
        }
        setTaxes()
      }
    
    /**
     * Actualizar los valores del item de la factura en función del producto/servicio seleccionado
     * @param {int} index Índice que ocupa ese item en el array de items de factura 
     * @param {Item} val
     */
    const updateItemForm = (index, val) => {
        const { id, code, name, amount, quantity, observations, tax, pit, type  } = val
        invoice.value.items[index].code = code ?? null
        invoice.value.items[index].vat = tax.value
        invoice.value.items[index].pit = pit
        invoice.value.items[index].item = name
        invoice.value.items[index].amount = amount
        invoice.value.items[index].quantity = quantity ?? 1
        invoice.value.items[index].observations = observations
        invoice.value.items[index].type=type
        invoice.value.items[index].id=id
        invoice.value.items[index].isNew=true
      }

      /**
       * Añadir un item al array de items de factura
       */
      const addNewItemInItemForm = function() {
        invoice.value.items.push(JSON.parse(JSON.stringify(item)))
      }

      /**
       * Borrar un item del array de items de factura
       */
      const removeItem = function(index) {
        invoice.value.items.splice(index, 1)
      }

      // Datos para selects
      const settings = ref({})
      const products = ref([])
      const students =ref([])
      const accountsOptions = ref([])
      const paymentMethodsOptions  = ref([])
      const cashesOptions=ref([])
      const groupsOptions = ref([])
      const itemsOptions = ref([])
      const suggestionsText = ref("")
      const customerOptions = ref([])
      const vatsOptions = ref([])
      const pitsOptions=ref([])
      const itemsSuggestions = ref([])
      const customersSuggestions = ref([])
      const correctingOptions = ref([])
      const economicActivityOptions = ref([])
      const itemTypeOptions= ref([{text: 'Suplido', value: true}, {text: 'Corriente', value: false}])
      const expenseItemTypeOptions= ref([{text: 'Activo', value: true}, {text: 'Corriente', value: false}])

      const accountingAccountOptions=ref([])

      const fetchCorrectingReasons = async function () {
        let response = await getCorrectingReasons()
        correctingOptions.value = response.data.correcting_reasons
      }

      const fetchAccountingAccounts = async function (account_group_id) {
        let response = await getAccountingAccounts({accounting_group: account_group_id, subaccount:false})
        return response.data.accounting_accounts
      }

      const fetchGroups = async function() {
        groupsOptions.value = (await getGroups()).data.groups
        if (groupsOptions.value.length == 1) {
          invoice.value.group = groupsOptions.value[0]
        }
      }
      
      const fetchStudents = async function () {
        students.value = (await getStudents(defaultQuery.value)).students
        getCustomerSuggestions()
      }

      const fetchAccounts = async function () {
        accountsOptions.value = (await getAccounts(defaultQuery.value)).data.accounts
        getCustomerSuggestions()
      }


      const fetchProducts = async function ()  {
        products.value = (await getProducts(defaultQuery.value)).data.products
        products.value.forEach((product) => {
          product.name='PRODUCTO - ' + product.search_name
          product.type="product"
        })
        itemsOptions.value.push(...products.value)
      }
      
      const fetchCashes = () => {
        axios.get('cashes').then(response => { cashesOptions.value=response.data.cashes})
      }

      const fetchTaxes = async function () {
        vatsOptions.value = await getTaxes()
      }

      const fetchPits = () => {
        axios.get('pits').then(response => { pitsOptions.value=response.data})
      }

      const fetchPaymentMethods = async function () {
          paymentMethodsOptions.value = (await getPaymentMethods()).data
      }

      const fetchSettings = async function () {
        settings.value = await getPublicSettings()
        invoice.value.settings_company_name=settings.value.company_name
        invoice.value.settings_cif=settings.value.cif
        invoice.value.settings_address=settings.value.address
        invoice.value.settings_city=settings.value.city
        invoice.value.settings_province=settings.value.province ? settings.value.province.name :''
        invoice.value.settings_country=settings.value.country ? settings.value.country.name :''
        invoice.value.settings_phone=settings.value.phone
        invoicePit.value=settings.value.pit ? settings.value.pit.value : null

        pitBeforeUpdated.value=settings.value.pit ? settings.value.pit.value : null
      }

      const fetchEconomicActivities = async function () { 
        let response = await getEconomicActivities()  
        economicActivityOptions.value = response.data.economic_activities
      }


      const getCustomerSuggestions = () => {
        customerOptions.value=[]
        customerOptions.value.push(...students.value)
        customerOptions.value.push(...accountsOptions.value)

        const filteredCustomerData = customerOptions.value.filter(function(client){
          return client.search_name.toLowerCase().includes(suggestionsText.value.toLowerCase())
        })
          
        customersSuggestions.value = [{
          data: filteredCustomerData
        }]

      }

      watch(() => invoice.value.is_supplied, () => {
        if (invoice.value.is_supplied===true) { invoice.value.accounting_account=null; invoice.value.accounting_subaccount=null; }
      })

      
      
      
      fetchStudents()
      fetchAccounts()
      fetchGroups() 
      fetchProducts()
      fetchTaxes()
      fetchPaymentMethods()
      fetchCashes()
      fetchPits()
      fetchSettings()
      fetchEconomicActivities()
      
    return {
        // Invoice
        getPits,
        getTaxes,
        getSubtotal,
        getDiscount,
        getTaxableBase,
        getTotalAmount,
        calculateInvoice,
    
        // InvoiceItems
        calculateItem,
        getItemSubtotal,
        getItemTaxableBase,
        getItemTotalAmount,
        
        // Impuestos
        setNullPit, 
        setExentVat, 
        setPit, 
        setVat,
        setBankAccount,
        setBillingData,
        validateInvoice,
        
        // Popover
        // updateDiscountTax,
        // changeToCurrentTax,
        // discountBeforeUpdated,
        // vatBeforeUpdated,
        // pitBeforeUpdated,

        updateItemForm,
        updateCustomerForm,
        onCustomerInputChange,
        onItemInputChange,
        addNewItemInItemForm,
        removeItem,
        onItemTypeInput,
        onAccountingInput,
        
        setAccountingAccount,
        setEconomicActivity,
        setCashVisibility, 
        setTaxesVisibility,
        setTaxes,
        showCashes,
        applyPIT, 
        applyVAT, 

        invoice,
        item,
        type,
        settings,

        fetchStudents, 
        fetchAccounts,
        fetchCorrectingReasons,
        fetchAccountingAccounts,

        // Opciones
        customersSuggestions, 
        itemsSuggestions,
        groupsOptions,
        paymentMethodsOptions, 
        vatsOptions,
        pitsOptions,
        cashesOptions,
        itemsOptions,
        economicActivityOptions,
        itemTypeOptions,
        expenseItemTypeOptions,
        accountingAccountOptions,
        correctingOptions,
        invoicePit,
    }

}